import {Component, Input, OnInit} from '@angular/core';
import {Event} from "../models/event";
import {Router, RouterLink} from "@angular/router";
import {ImageService} from "../services/image.service";
import {DatePipe, LowerCasePipe, NgIf, NgOptimizedImage} from "@angular/common";
import {TruncatePipe} from "../pipes/transform.pipe";


@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.css'],
  imports: [
    NgOptimizedImage,
    LowerCasePipe,
    DatePipe,
    RouterLink,
    TruncatePipe,
    NgIf
  ],
  standalone: true
})
export class EventCardComponent implements OnInit {
  @Input("event") event!: Event;
  @Input("border") border!: boolean;

  mouseOvered!: boolean;

  constructor(private router: Router, private imgService: ImageService) {}

  ngOnInit(): void {
    this.eventDateTime();
  }

  /**
   * Gets the relative URL of a Firebase Storage absolute URL for use with optimized images
   */
  relativeUrl(): string {
    return this.imgService.getRelativeURL(this.event.images[0]);
  }

  /**
   * Checks if the event dates are on the same day and month
   *
   * @return Boolean
   */
  eventDateTime(): Boolean {
    return this.event.start.toDate().getMonth() != this.event.end.toDate().getMonth() || this.event.start.toDate().getDay() != this.event.end.toDate().getDay();
  }

  /**
   * Redirects the user to the event details page
   */
  redirectToEvent() {
    this.router.navigate(['/activiteit/' + this.event.id]);
  }

  public endHover() {
    console.log('test')
  }
}
